import React, { useState } from "react";
import emailjs from "@emailjs/browser";

function ContactForm() {
  const [formData, setFormData] = useState({
    full_name: "",
    email: "",
    phone: "",
  });

  const [message, setMessage] = useState("");

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    emailjs
      .send(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        formData,
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY,
      )
      .then(
        () => {
          setMessage("Message sent successfully!");
          setFormData({
            full_name: "",
            email: "",
            phone: "",
          });
        },
        () => {
          setMessage("Failed to send message. Try again.");
        },
      );
  };

  return (
    <div className="col l6 s12">
      <h4>Get in Touch</h4>

      <form className="col s12" onSubmit={handleSubmit}>
        {/* FULL NAME */}
        <div className="row">
          <div className="input-field col s12">
            <input
              name="full_name"
              type="text"
              className="validate"
              value={formData.full_name}
              onChange={handleChange}
              required
            />
            <label htmlFor="full_name">Full Name</label>
          </div>
        </div>

        {/* EMAIL */}
        <div className="row">
          <div className="input-field col s12">
            <input
              name="email"
              type="email"
              className="validate"
              value={formData.email}
              onChange={handleChange}
              required
            />
            <label htmlFor="email">Email</label>
          </div>
        </div>

        {/* PHONE */}
        <div className="row">
          <div className="input-field col s12">
            <input
              name="phone"
              type="tel"
              className="validate"
              pattern="[0-9]{10}"
              value={formData.phone}
              onChange={handleChange}
              required
            />
            <label htmlFor="phone">Phone Number</label>
          </div>
        </div>

        <button
          type="submit"
          className="btn btn-large indigo darken-4 waves-effect waves-light"
        >
          Send Message
        </button>

        {message && <p>{message}</p>}
      </form>
    </div>
  );
}

export default ContactForm;